import {
  PyramidShippingItem,
  ShippingOptionItem,
  ShippingOptionsData,
  ShippingOptionType,
} from '@package/core/src/shipping/types';
import { SubOrder } from '@package/core/src/shoppingCart/types';

export type SelectedShippingOption = (ShippingOptionItem | PyramidShippingItem) & {
  subOrderId: number;
  vendorName: string;
  latestDeliveryDate: number | string | undefined;
  deliveryDate: string;
  deliveryTime: string;
};

export const getSelectedShippingOptions = (
  shippingOptions: ShippingOptionsData | null,
  subOrders: Array<SubOrder>,
): Array<SelectedShippingOption> => {
  if (!shippingOptions) return [];

  const selectedShippingOptions = subOrders.map((subOrder) => {
    const shippingOptionType = subOrder.vendorId ? ShippingOptionType.Shippings : ShippingOptionType.PyramydShippings;
    const shippingOptionsForSuborder = shippingOptions[shippingOptionType].find(
      (option: any) => option.suborderId === subOrder.orderId,
    );

    if (!shippingOptionsForSuborder) return null;

    const selectedOption = shippingOptionsForSuborder.calculateShippings.find((option: any) =>
      subOrder.vendorId
        ? option.methodId === subOrder.vendorShipping.shippingOption
        : option.number === subOrder.vendorShipping.shippingOption,
    );
    return selectedOption
      ? {
          ...selectedOption,
          subOrderId: subOrder.orderId,
          vendorName: subOrder.vendor,
          latestDeliveryDate:
            selectedOption.latestDeliveryDate ||
            ('deliveryDate' in selectedOption ? selectedOption.deliveryDate : undefined),
        }
      : null;
  });

  return selectedShippingOptions.filter((option): option is SelectedShippingOption => option !== null);
};
